import { render, staticRenderFns } from "./confirmAccount.pug?vue&type=template&id=11323b63&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./confirmAccount.scss?vue&type=style&index=0&id=11323b63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11323b63",
  null
  
)

export default component.exports